<template>

  <transition v-if="isModalVisible" name="modal-fade">
    <div class="modal-backdrop">
      <div aria-describedby="modalDescription"
           aria-labelledby="modalTitle"
           class="modal modal-custom-text"
           role="dialog"
      >

        <section
            id="modalDescription"
            class="modal-body"
        >
          <slot name="body">
            {{ comments }}
          </slot>
        </section>

        <footer class="modal-footer">
          <button
              aria-label="Close modal"
              class="btn"
              type="button"
              @click="closeModal"
          >
            Fermer
          </button>
        </footer>
      </div>
    </div>
  </transition>

  <div v-if="ifTestFinished" class="file-section file-section--active">
    <div class="file-section-content">
      <div>
        <div class="file-circle file-circle--active"/>
      </div>
      <div class="file-section-content-label">Eligibilité</div>
    </div>
  </div>
  <div v-else-if="ifEligible" class="file-section file-section--active">
    <div class="file-section-content">
      <div>
        <div class="file-circle file-circle--active"/>
      </div>
      <div class="file-section-content-label">Eligibilité</div>
      <div>
        <div class="file-icon file-icon--active"><img src="@/assets/img/file/indicator.png"></div>
      </div>
    </div>
    <div class="file-section-info">
      <div class="file-section-info-separator"/>
      Votre candidature est éligible, vous accédez aux tests en ligne. L'objectif des tests est d'optimiser votre parcours si vous entrez en formation ASV en alternance. La formation sera personnalisée en fonction de vos résultats aux tests.
    </div>
  </div>
  <div v-else-if="ifEligible === false && statut == 'Refusé'" class="file-section file-section--critical file-section--pointer">
    <div class="file-section-content">
      <div>
        <div class="file-circle file-circle--critical"/>
      </div>
      <div class="file-section-content-label">Eligibilité</div>
      <div>
        <div class="file-icon file-icon--critical"><img src="@/assets/img/file/indicator.png"></div>
      </div>
    </div>
    <div class="file-section-info">
      <div class="file-section-info-separator"/>
      <div class="file-section-info-click" @click="openModal">
        Lire le motif de refus
      </div>
      Vous pouvez mettre à jour votre candidature pendant 30 jours afin d'effectuer une nouvelle demande d'éligibilité. Passé ce délai, votre candidature sera supprimée.
    </div>
  </div>
  <div v-else-if="ifEligible === false" class="file-section file-section--critical">
    <div class="file-section-content">
      <div>
        <div class="file-circle file-circle--critical"/>
      </div>
      <div class="file-section-content-label">Eligibilité</div>
      <div>
        <div class="file-icon file-icon--critical"><img src="@/assets/img/file/indicator.png"></div>
      </div>
    </div>
    <div class="file-section-info">
      <div class="file-section-info-separator"/>
      Vous pouvez mettre à jour votre candidature pendant 30 jours afin d'effectuer une nouvelle demande d'éligibilité. Passé ce délai, votre candidature sera supprimée.
    </div>
  </div>
  <div v-else class="file-section">
    <div class="file-section-content ">
      <div>
        <div class="file-circle"/>
      </div>
      <div class="file-section-content-label">Eligibilité</div>
      <div>
        <div class="file-icon"><img src="@/assets/img/file/padlock-close.png"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FileEligible",
  props: {
    ifEligible: Boolean,
    statut: String,
    ifTestFinished: Boolean,
    comments: String
  },
  data() {
    return {
      isModalVisible: false
    }
  },
  methods: {
    closeModal() {
      this.isModalVisible = false
    },
    openModal() {
      this.isModalVisible = true
    }
  },
  mounted() {
  }
};
</script>